import React, { Component } from 'react';

import { Modal } from 'components/modal';
import { MembershipEventService } from 'modules/membershipEvent';
import { EVENTS } from 'modules/membershipEvent/constants';
import { UserService } from 'modules/user';
import PropTypes from 'prop-types';

import { VIDEOS } from './constants';

import './PropagationModal.scss';

export default class PropagationModal extends Component {
  static propTypes = {
    eventName: PropTypes.string.isRequired
  };

  onDisable = () => {
    this.propagationModal.removeChild(this.propagationModal.childNodes[0]);
    MembershipEventService.dismissEvent(EVENTS[this.props.eventName]);
  };

  get video() {
    const language = UserService.language.toUpperCase();

    return (
      VIDEOS[this.props.eventName] && VIDEOS[this.props.eventName][language]
    );
  }

  render() {
    const video = this.video;

    if (!video) {
      return null;
    }

    return (
      <Modal className="propagation-modal" title onClose={this.onDisable}>
        <Modal.Body>
          <div
            ref={(ref) => (this.propagationModal = ref)}
            className="embed-responsive embed-responsive-16by9"
          >
            <iframe
              allowFullScreen="allowfullscreen"
              className="embed-responsive-item"
              frameBorder="0"
              src={video}
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
